/**
 * Puts a server refusal where the reader can act on it: once, next to the
 * submit button of the form whose mutation failed.
 *
 * A form renders this with its mutation's `error`; react-query clears that
 * error on the next attempt, so a retry that works takes the message down.
 */
export function ServerError({ error }: Readonly<{ error?: unknown }>) {
  if (!(error instanceof Error)) return null;
  return (
    <p className="form-error" role="alert">
      {error.message}
    </p>
  );
}
